import React from 'react';

const BulletPoints = ({ item }) => {
  const newItem = item.split(', ');
  return (
    <ul style={{ margin: '0' }}>
      {newItem.map((bringItem, index) => (
        <li key={index} style={{ padding: '3px 0', fontSize: '13px' }}>
          {bringItem}
        </li>
      ))}
    </ul>
  );
};

export default BulletPoints;
